document.addEventListener("DOMContentLoaded", function() {
  var readMore = document.getElementById("read-more");

  if(readMore){
  
    var gradientOverlay = document.querySelector(".gradient-overlay");
    var descriptionContainer = document.querySelector(".product__description-container");
    var description = document.getElementById("product-description");
  
    var downArrowSVG = '<svg class="arrow" width="10" height="10" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 15c-.3 0-.6-.1-.8-.4l-11-13C-.2 1.2-.1.5.3.2c.4-.4 1.1-.3 1.4.1L12 12.5 22.2.4c.4-.4 1-.5 1.4-.1.4.4.5 1 .1 1.4l-11 13c-.1.2-.4.3-.7.3z" fill="currentColor"/></svg>';
    var upArrowSVG = '<svg class="arrow" width="10" height="10" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 15c-.3 0-.6-.1-.8-.4l-11-13C-.2 1.2-.1.5.3.2c.4-.4 1.1-.3 1.4.1L12 12.5 22.2.4c.4-.4 1-.5 1.4-.1.4.4.5 1 .1 1.4l-11 13c-.1.2-.4.3-.7.3z" fill="currentColor"/></svg>';
  
    function throttleExpansion(start, end, duration, delay, callback) {
      let current = start;
      const increment = (end - start) / (duration / delay);
  
      function expand() {
        if (current < end) {
          current += increment;
          description.style.webkitLineClamp = Math.ceil(current);
          descriptionContainer.style.maxHeight = `${current * 2}em`;
          setTimeout(expand, delay);
        } else {
          descriptionContainer.style.maxHeight = "none";
          description.style.display = 'block';
          description.style.webkitLineClamp = "unset";
          gradientOverlay.style.opacity = 0;
          descriptionContainer.style.paddingBottom = '20px'; /* Add padding when expanded */
          readMore.classList.add('expanded');
          readMore.classList.add('less');
          readMore.innerHTML = upArrowSVG + ' less ' + upArrowSVG;
          if (callback) callback();
        }
      }
  
      expand();
    }
  
    function throttleCollapse(start, end, duration, delay, callback) {
      let current = start;
      const decrement = (start - end) / (duration / delay);
  
      function collapse() {
        if (current > end) {
          current -= decrement;
          description.style.webkitLineClamp = Math.ceil(current);
          descriptionContainer.style.maxHeight = `${current * 2}em`;
          setTimeout(collapse, delay);
        } else {
          descriptionContainer.style.maxHeight = "16em"; /* Adjusted for 8 lines */
          description.style.display = '-webkit-box';
          description.style.webkitLineClamp = 8; /* Adjusted for 8 lines */
          gradientOverlay.style.opacity = 1;
          descriptionContainer.style.paddingBottom = '0'; /* Remove padding when collapsed */
          readMore.classList.remove('expanded');
          readMore.classList.remove('less');
          readMore.innerHTML = downArrowSVG + ' more ' + downArrowSVG;
          if (callback) callback();
        }
      }
  
      collapse();
    }
  
    function toggleDescription() {
      if (descriptionContainer.classList.contains('expanded')) {
        descriptionContainer.classList.remove('expanded');
        throttleCollapse(20, 8, 500, 50);
      } else {
        descriptionContainer.classList.add('expanded');
        throttleExpansion(8, 20, 500, 50);
      }
    }
  
    // Calculate the number of lines in the description
    function calculateLines(element) {
      if(!element) return;
      const lineHeight = parseFloat(getComputedStyle(element).lineHeight);
      const height = element.scrollHeight;
      return Math.floor(height / lineHeight);
    }
  
    const numLines = calculateLines(description);
  
    if (numLines <= 8) {
      readMore.style.display = 'none';
      gradientOverlay.style.display = 'none';
      descriptionContainer.style.maxHeight = 'none';
      description.style.webkitLineClamp = 'unset';
    } else {
      readMore.addEventListener("click", toggleDescription);
      gradientOverlay.addEventListener("click", toggleDescription);
      // Initialize the read more text with arrows
      readMore.innerHTML = downArrowSVG + ' more ' + downArrowSVG;
    }

  }
  
});

// Display discount code, even if there are no items in the cart
document.addEventListener('DOMContentLoaded', function() {
  const urlParams = new URLSearchParams(window.location.search);
  const discountCode = urlParams.get('discount');

  if (discountCode) {
    document.cookie = `discount_code=${discountCode}; path=/`;

    // Apply discount if present in URL
    fetch(`/discount/${discountCode}`).then(() => {
      // Optionally refresh the cart or page here if needed
    });
  }

  // Check for discount code in cookie and display it
  const discountCookie = document.cookie.split('; ').find(row => row.startsWith('discount_code='));
  if (discountCookie) {
    const appliedDiscount = discountCookie.split('=')[1];
    // Fetch current discount applications from Shopify API
    fetch('/cart.js')
      .then(response => response.json())
      .then(data => {
        if (data && data.discount_applications && data.discount_applications.length > 0) {
          const currentDiscount = data.discount_applications[0].title;
          displayDiscountCode(currentDiscount);
        } else {
          displayDiscountCode(appliedDiscount);
        }
      });
  }
});

function displayDiscountCode(discountCode) {
  const discountElement = document.querySelector('.custom-discount-title');
  if (discountElement) {
    discountElement.textContent = discountCode;
  } else {
    const newDiscountElement = document.createElement('p');
    newDiscountElement.classList.add('custom-discount-title');
    newDiscountElement.textContent = discountCode;
    document.querySelector('.custom-discount-overlay').appendChild(newDiscountElement);
  }
}

// Navistone mailing code
(function (d, e, u) {
  var s = document.createElement(e);
  s.src = u;
  s.async = true;
  s.defer = true;
  var m = d.getElementsByTagName(e)[0];
  m.parentNode.insertBefore(s, m);
})(document, 'script', 'https://cdn.datasteam.io/js/datasteampx.js');
MGX = typeof MGX === 'undefined' ? [] : MGX;
MGX.push({
  AccessKey: 'B2CE8CBFCADC'
});
